
import React from 'react';

const ExerciseTypeDetail = () => {
  // Hardcoded example exercise details
  const exercise = {
    name: 'Squat',
    category: 'Lower Body',
    primaryMuscles: ['Quadriceps', 'Glutes', 'Hamstrings'],
    equipment: 'Barbell',
    difficulty: 'Intermediate',
    description: 'The squat is a fundamental lower body exercise that targets the quadriceps, glutes, and hamstrings. It is performed by lowering the hips from a standing position and then standing back up.'
  };

  return (
    <div className="exercise-detail-page">
      <h1>{exercise.name}</h1>
      <p><strong>Category:</strong> {exercise.category}</p>
      <p><strong>Primary Muscles:</strong> {exercise.primaryMuscles.join(', ')}</p>
      <p><strong>Equipment:</strong> {exercise.equipment}</p>
      <p><strong>Difficulty:</strong> {exercise.difficulty}</p>
      <p><strong>Description:</strong> {exercise.description}</p>
    </div>
  );
};

export default ExerciseTypeDetail;